import {NgModule} from "@angular/core";
import {ModalModule} from "ng2-bootstrap";
import {ClientNotesComponent} from "./client-notes.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NotesService} from "../../models/notes/notes.service";
import {PipesModule} from "../../pipes/pipes.module";
import {Roles} from "../../models/roles";
import {CompaniesService} from "../../models/companies/companies.service";

@NgModule({
    declarations: [ClientNotesComponent],
    imports: [
        ModalModule,
        CommonModule,
        FormsModule,
        PipesModule,
    ],
    exports: [ClientNotesComponent],
    providers: [
        NotesService,
        Roles,
        CompaniesService,
    ]
})

export class ClientNotesModule {
}


// WEBPACK FOOTER //
// ./src/app/modules/client-notes/client-notes.module.ts